import { graphql, useStaticQuery } from 'gatsby'
import { useIntl } from 'react-intl'

import {
  strapiJobDetailUrl,
  strapiProfileUrl,
} from '@utils/cms/strapiPageContext'
import { defaultLang } from '../../../../translations'

const useStrapiPageJobDetail = (): MCDC.Contentful.IPageJobDetailLink[] => {
  const { locale } = useIntl()
  const activeLocale = locale || defaultLang
  const { offers, profiles, data } = useStaticQuery(
    graphql`
      query StrapiPageJobDetailStaticQuery {
        offers: allStrapiPageGeneric(filter: { metaType: { eq: "offers" } }) {
          nodes {
            path
          }
        }
        profiles: allStrapiPageProfile {
          nodes {
            identifier
          }
        }
        data: allStrapiPageJobDetail {
          nodes {
            id
            identifier
            templateId
            title
          }
        }
      }
    `
  )

  const offersBaseUrl: string = offers.nodes[0]?.path || '/'
  const profileUrlByIdentifier = new Map<string, string>(
    (profiles.nodes || []).map((profile: { identifier?: string | null }) => [
      String(profile.identifier ?? ''),
      strapiProfileUrl(offersBaseUrl, profile.identifier),
    ])
  )

  return (
    data.nodes?.map(
      (entry: {
        id: string
        identifier?: string
        templateId?: string
        title?: string
      }): MCDC.Contentful.IPageJobDetailLink => {
        const profileUrl =
          profileUrlByIdentifier.get(String(entry.templateId ?? '')) ||
          strapiProfileUrl(offersBaseUrl, entry.templateId)
        const url = strapiJobDetailUrl(profileUrl, entry.identifier)

        return {
          id: entry.id,
          node_locale: activeLocale,
          identifier: entry.identifier || '',
          title: entry.title || '',
          fields: {
            linkTo: {
              label: entry.title || '',
              url,
              isExternal: false,
            },
            breadcrumbs: [],
          },
        }
      }
    ) || []
  )
}

export default useStrapiPageJobDetail
